import React from 'react';
import ReactDOM from 'react-dom';
import { StoreProvider } from './store';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import App from './App';
import * as serviceWorker from './serviceWorker';

import './assets/styles/index.scss';

// The package to read .env file
import dotenv from 'dotenv';
// Initialize dotenv module
dotenv.config();

const rootDiv = document.getElementById('root');

ReactDOM.render(
    <StoreProvider>
        <ToastContainer />
        <div id={'app-container'}>
            <App />
        </div>
    </StoreProvider>,
    rootDiv
);

serviceWorker.unregister();
